import React from 'react';
import { Section } from './Section';
import { ArrowRight, Truck, Flame, Tag } from 'lucide-react';
const badges = [{
  icon: Truck,
  label: 'Envío Gratis con 2+'
}, {
  icon: Flame,
  label: 'Stock Limitado'
}, {
  icon: Tag,
  label: 'Hoy 20% OFF'
}];
export function Offer() {
  return <Section id="oferta" data-id="element-144">
      <div className="bg-[#0A0A0A] text-white rounded-[2rem] md:rounded-[3rem] py-20 md:py-28 px-6 md:px-16 text-center relative overflow-hidden" data-id="element-145">
        {/* Orange glow */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#FF6B1A] rounded-full blur-[120px] opacity-30 pointer-events-none" data-id="element-146" />
        <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-[#FF6B1A] rounded-full blur-[100px] opacity-15 pointer-events-none" data-id="element-147" />

        <div className="relative z-10 max-w-3xl mx-auto flex flex-col items-center" data-id="element-148">
          <div className="flex flex-wrap justify-center gap-3 mb-10" data-id="element-149">
            {badges.map((badge, i) => <span key={i} className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-white/15 bg-white/5 backdrop-blur-sm text-xs font-medium tracking-wider uppercase" data-id="element-150">
                <badge.icon size={14} className="text-[#FF6B1A]" strokeWidth={2} data-id="element-151" />
                {badge.label}
              </span>)}
          </div>

          <h2 className="text-4xl md:text-6xl font-light tracking-tight leading-tight mb-6 text-balance" data-id="element-152">
            Llevá tu lectura al{' '}
            <span className="font-semibold text-[#FF6B1A]" data-id="element-153">
              siguiente nivel
            </span>
            .
          </h2>

          <p className="text-white/60 text-lg font-light mb-12 max-w-xl" data-id="element-154">
            Aprovechá el descuento de hoy. Envío gratis comprando 2 unidades o
            más.
          </p>

          <button className="px-10 py-5 bg-[#FF6B1A] text-white rounded-full font-semibold text-lg hover:bg-white hover:text-[#0A0A0A] hover:scale-105 transition-all duration-300 inline-flex items-center gap-3 group" data-id="element-155">
            Comprar ahora con descuento
            <ArrowRight size={20} className="transition-transform group-hover:translate-x-1" data-id="element-156" />
          </button>

          <p className="text-white/40 text-xs mt-6 tracking-wider uppercase" data-id="element-157">
            Pago seguro · Garantía de 7 días
          </p>
        </div>
      </div>
    </Section>;
}